const template = `
	<div class="domain-picker">
		<div class="dp-tabs">
			<span
				class="dp-tab"
				:class="{'dp-tab-active': activeTab === 'list'}"
				@click="setActive('list')"
			>{{ ii('LIST') }}</span>
			<span
				class="dp-tab"
				:class="{'dp-tab-active': activeTab === 'custom'}"
				@click="setActive('custom')"
			>{{ ii('CUSTOM') }}</span>
		</div>
		<div v-if="activeTab === 'list'">
			<div class="dp-opts">
				<label class="chb">
					<input v-model="withSub" type="checkbox">
					{{ ii('INCLUDE_SUBDOMAINS') }}
				</label>
			</div>
			<multi-sel
				v-if="ready"
				v-model="val"
				:items="items"
				:with-not="false"
				open="1"
				@change="onChange"
			></multi-sel>
		</div>
		<div v-if="activeTab === 'custom'" class="dp-custom">
			<s-text-field v-model="customVal" placeholder="*.example.com"></s-text-field>
			<div class="dp-custom-bottom">
				<span class="pic-link" @click="emitVal">
					<i class="fa fa-save"></i>
					<span>{{ ii('APPLY') }}</span>
				</span>
			</div>
		</div>
	</div>
`;

export default {
	template,
	props: [
		'value',
		'items'
	],
	data() {
		return {
			ready: false,
			val: null,
			withSub: true,
			activeTab: 'list',
			customVal: ''
		};
	},
	methods: {
		setActive(tab) {
			this.activeTab = tab;
		},
		acceptVal() {
			let val = this.value;

			this.activeTab = (val && val.indexOf('@') === 0 ? 'custom' : 'list');

			if (this.activeTab === 'list') {
				if (val && val.indexOf('base_') === 0) {
					val = val.slice('base_'.length);
					this.withSub = false;
				} else {
					this.withSub = true;
				}

				this.val = val;
			} else {
				this.customVal = val.slice(1);
			}
		},
		emitVal() {
			let val;

			if (this.activeTab === 'list') {
				val = this.val;
				if (val && !this.withSub) {
					val = 'base_' + val;
				}
			} else {
				val = '@' + this.customVal;
			}

			this.$emit('input', val);
			this.$emit('change');
		},
		onChange(e) {
			this.emitVal();
		}
	},
	mounted() {
		this.acceptVal();
		this.ready = true;
	}
};